import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PreferenceInformation } from '../../types/user';

const initialState: PreferenceInformation = {
  hopeToGain: '',
  preferredPartnerId: undefined,
  preferredPartnerName: undefined,
  preferredCoachGenders: '',
  preferredCoachEthnicities: [],
  preferredCoachSexualOrientations: '',
};

export const preferenceInformationSlice = createSlice({
  name: 'preferenceInformation',
  initialState,
  reducers: {
    setPreferenceInformation: (_, action: PayloadAction<PreferenceInformation>) => {
      return action.payload;
    },
    clearPreferenceInformation: () => initialState
  }
});

export const { setPreferenceInformation, clearPreferenceInformation } = preferenceInformationSlice.actions;
export default preferenceInformationSlice.reducer;